import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import MenuService from "../../service/MenuService";
import { searchMenuParams } from "../../service/serviceObjects";
import { isMobile } from "../../utilities/general";
import { groupCategoriesByElementCount, groupMenuByCategory, mergeSmallCategories, truncateDescriptionString } from "../../utilities/menuItemUtil";
import { Card } from 'primereact/card'; // if you use PrimeReact Card
import { ProgressSpinner } from 'primereact/progressspinner';

const PublicMenuComponentDisplay = (props) => {
    const { currentDay, currentCateringId, currentCustomerId, currentCustomerKey } = props
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [menuForCurrentDays, setMenuForCurrentDays] = useState([]);
    const [currentMenuIndex, setCurrentMenuIndex] = useState(0);
    const [selectedDate, setSelectedDate] = useState(currentDay);
    const [categorizedMenuForCurrentDay, setCategorizedMenuForCurrentDay] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const [editId, setEditId] = useState();
    const menuService = new MenuService();
    const { t } = useTranslation();
    useEffect(() => {
        if (menuForCurrentDays?.length > 0) {
            const interval = setInterval(() => {
                setCurrentMenuIndex(prevIndex => {
                    if (prevIndex >= menuForCurrentDays.length - 1) {
                        return 0; // restart from 0
                    } else {
                        return prevIndex + 1; // next item
                    }
                });
            }, 15000); // 5 seconds

            return () => clearInterval(interval); // clear on unmount
        }
    }, [menuForCurrentDays.length]);
    const images = menuForCurrentDays[currentMenuIndex]?.menuItemDTOList
        ?.map(item => item.imagePreview)
        .filter(Boolean);
    useEffect(() => {
        if (images && images.length > 0) {
            const interval = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, 3000); // Change image every 5 seconds

            return () => clearInterval(interval); // Cleanup on unmount
        }
    }, [images, menuForCurrentDays.length]);
    const getActiveMenus = (first, last) => {
        let searchObject = {
            ...searchMenuParams,
            minDate: first,
            maxDate: last,
            customerId: currentCustomerId,
            cateringId: currentCateringId,
            customerKey: currentCustomerKey
        }
        setShowProgressBar(true)
        menuService.searchPublic(searchObject).then(data => {
            setTimeout(() => {
                setShowProgressBar(false)
            }, 500);
            setMenuForCurrentDays(data?.items)
            if (data?.items?.[0]?.menuItemDTOList) {
                setCategorizedMenuForCurrentDay(groupMenuByCategory(data?.items?.[0]?.menuItemDTOList))
            }
        })
    }
    useEffect(() => {
        const fetchMenus = () => {
            setCategorizedMenuForCurrentDay([]);
            setMenuForCurrentDays([]);
            getActiveMenus(
                selectedDate,
                moment(selectedDate, 'YYYY-MM-DD').add(5, 'days').format('YYYY-MM-DD')
            );
        };

        // Call it once immediately when the component mounts
        fetchMenus();

        // Set interval to call it every 24 hours (86400000 ms)
        const intervalId = setInterval(fetchMenus, 12 * 60 * 60 * 1000);
        // const intervalId = setInterval(fetchMenus, 1 * 60 * 1000);

        // Clear interval on component unmount
        return () => clearInterval(intervalId);
    }, []);
    const returnOneMenuItem = (singleElement, mini, isEdit) => {
        let description = singleElement?.description?.split('•').map(item => item.trim());

        return <div className="col-12 border-radius-2 mt-5" >
            <div className="p-1">
                <div className="relative mb-3">
                    <div className="text-900 font-bold" style={{ fontSize: currentCateringId == "7" && singleElement?.itemCategoryName == "Set meni" ? "4rem" : (singleElement?.name?.length > 30 ? '3.0em' : "3.6em") }}>{truncateDescriptionString(singleElement.name, 80)}</div>
                    <span className="text-900 font-bold px-1" style={{ borderRadius: '3rem' }}>
                        <span className="text-900 text-5xl mt-1">{singleElement?.price},00 RSD</span>
                    </span>
                </div>
                {currentCateringId == "7" && singleElement?.itemCategoryName == "Set meni" && <div className="my-2 surface-300 p-6" >
                    <span className="mr-3 h-full w-full font-bold" style={isMobile() ? { fontSize: '3.2em', color: '#000' } : { fontSize: "3.2em", color: '#000' }}>
                        {/* {singleElement?.description} */}
                        {description.map((item, index) => (
                            <div className='my-4' key={index}>{item}</div>  // each item on a new line
                        ))}
                    </span>
                </div>}
            </div>
        </div>
    }
    const returnAllElements = () => {
        if (menuForCurrentDays?.length > 0) {
            return <div className='grid m-0'>
                <div className='col-12 text-center border-bottom-1 border-500 mb-6 -mt-8'>
                    <span className='text-8xl '> {t(moment(menuForCurrentDays?.[currentMenuIndex].menuDate, 'YYYY-MM-DD').format('dddd')) + " - " + moment(menuForCurrentDays?.[currentMenuIndex].menuDate, 'YYYY-MM-DD').format("DD/MM/YYYY")}</span>

                </div>
                {returnElementsForDate(menuForCurrentDays[currentMenuIndex])}
            </div>
        }
    }
    function chunkArray(arr, size) {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    }

    const returnElementsForDate = (currentMenuItems) => {
        let edit = false
        if (currentMenuItems?.menuItemDTOList) {
            let categorizedMenuForCurrentDay = groupMenuByCategory(currentMenuItems?.menuItemDTOList)
            if (categorizedMenuForCurrentDay?.length > 0) {
                const groupedCategories = groupCategoriesByElementCount(categorizedMenuForCurrentDay);

                return <div className="grid w-full px-8">
                    {groupedCategories.map((group, groupIdx) => (
                        <div
                            key={groupIdx}
                            className="grid gap-4 mb-3 mx-2"
                            style={{
                                gridTemplateColumns: group.type === 'vertical' ? '1fr' : 'repeat(auto-fit, minmax(30rem, 1fr))',
                            }}
                        >
                            {group.categories.map((category) => {
                                if (category.categoryName != "Doručak") {
                                    return <div key={category.categoryName}>
                                        {/* Category Name */}
                                        <div
                                            className="text-900 font-bold mb-4"
                                            style={isMobile() ? { fontSize: '7.2vw' } : { fontSize: '3.5vw' }}
                                        >
                                            {category.categoryName}
                                        </div>

                                        {/* Cards with items inside */}
                                        <div className="grid gap-4 mx-2">
                                            {chunkArray(category.elements, 4).map((group, groupIdx) => (
                                                <div
                                                    key={groupIdx}
                                                    className="p-2 m-2 border-radius-2"
                                                    style={{
                                                        backgroundColor: 'rgba(232, 232, 232, 0.8)',
                                                        width: currentCateringId == "7" && category.categoryName == "Set meni" ? "250rem" : "50rem",
                                                        height: currentCateringId == "7" && category.categoryName == "Set meni" ? '800px' : "100%"
                                                    }}
                                                >
                                                    {/* Items stacked vertically */}
                                                    <div className="grid gap-2">
                                                        {group.map((item, itemIdx) => (
                                                            <div key={itemIdx} className={currentCateringId == "7" && category.categoryName == "Set meni" ? "my-2 mx-5 col-3" : "my-2 col-12"}>
                                                                {returnOneMenuItem(item, edit, edit)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                }
                            })}
                        </div>
                    ))}
                </div>


            } else {
                return noMenuComponent
            }
        }
        let itemCategoryOptions = [
        ]
        if (categorizedMenuForCurrentDay?.length > 0) {
            itemCategoryOptions = categorizedMenuForCurrentDay.map(x => ({
                value: x.categoryName, name: x.categoryName
            }))
        }

    }

    const noMenuComponent = (
        <div className="flex justify-content-center align-items-center w-full h-screen">
            <ProgressSpinner style={{ width: '200px', height: '200px' }} />

        </div>

    )
    return (
        <div style={{zoom:'0.3'}}
        >
            {images && images.length > 0 && (
                <div className=" surface-0 ">
                    {images.map((img, index) => (
                        index === currentImageIndex && <img
                            key={index}
                            src={"data:image/png;base64," + img}
                            alt=""
                            style={{ height: '100%', width: "100%", backgroundSize: 'cover' }}
                            className={`absolute animation-duration-1000 animation-iteration-1 ${index === currentImageIndex ? 'opacity-30' : 'opacity-0'}`}
                        />
                    ))}
                    <div className="absolute inset-0 bg-black opacity-30"></div> {/* optional dark overlay */}
                </div>
            )}
            <div className='col-12' style={{ height: '5rem' }}>
                <div className="py-3 px-5 flex align-items-center justify-content-between relative lg:static" >
                    <img src={window.location.origin + "/assets/layout/images/logo.png"} alt="Image" height={60} className="" />

                </div>

            </div>

            <div className="col-5 surface-0 text-900 text-right mt-2 ">
                <img src={"data:image/png;base64," + menuForCurrentDays[0]?.cateringLogo} alt="Image" height="90" className="mr-0 lg:mr-6" style={{ position: 'absolute', right: 5, top: 10, zIndex: 1002 }} />
            </div>

            {menuForCurrentDays?.length == 0 && noMenuComponent}
            {returnAllElements()}


            {/* <div className="col-12 surface-section px-4 py-6 md:px-6 lg:px-8 text-center">
                <img src={window.location.origin + "/assets/layout/images/logo.png"} alt="Image" height="50" />
                <div className="font-medium text-900 mt-4 mb-3">&copy; 2024 bidtech.rs</div>
                <p className="text-600 line-height-3 mt-0 mb-4">Explore food world with us.</p>
            </div> */}
        </div>
    );
}

export default withRouter(PublicMenuComponentDisplay);